<template>
    <div class="card">
        <div
            v-if="header"
            class="card-header">
            提供中のサービス
        </div>

        <div class="card-body">
            <p
                v-if="!header"
                class="font-weight-bold mb-2"
                style="font-size: 1rem;">
                提供中のサービス
            </p>
            <div
                v-if="inProgress"
                class="d-flex justify-content-center align-items-center p-3">
                <b-spinner variant="yokumiru-user"></b-spinner>
            </div>
            <div v-else-if="currentUser && currentUser.subscription">
                <div>
                    <h5 class="subscriptionName">{{ currentUser.plan.common_name }}</h5>
                    <div class="subscriptionPeriod">
                        <div>{{ `ご利用期間: ${periodStart} 〜 ${periodEnd}（日本時間）` }}</div>
                        <div v-if="canceledAt !== null" class="text-muted">
                            {{ `${canceledAt} にキャンセル済み` }}
                        </div>
                        <div v-else-if="pausedAt !== null" class="text-danger font-weight-bold">
                            {{ helper.isCyclePlan(currentUser.plan) ? '利用停止中（自動更新されません）' : '利用停止中' }}
                        </div>
                        <div v-else-if="helper.isCyclePlan(currentUser.plan)" class="text-success">
                            {{ `${cycleWillUpdateAt} に自動更新予定` }}
                        </div>
                    </div>
                </div>
                <div class="d-flex">
                    <div v-if="canCancel" class="mt-2 mr-3 pt-1">
                        <b-button
                            size="sm"
                            variant="yokumiru-gray"
                            @click="openModalSubscriptionCancel">
                            サービスのキャンセル
                        </b-button>
                    </div>
                    <div v-if="shouldUpload" class="mt-2 pt-1">
                        <b-button
                            size="sm"
                            variant="yokumiru-orange"
                            @click="openModalSubscriptionFileUpload">
                            書類のアップロード
                        </b-button>
                    </div>
                </div>
                
            </div>
            <div v-else-if="currentUser && !currentUser.subscription">
                <div class="text-muted">プランはキャンセルされました</div>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'
    import moment from "moment-timezone"

    export default {
        props: {
            header: {
                type: Boolean,
                default: true,
            },
            user: {
                type: Object,
                required: true,
            },
            cancelable: {
                type: Boolean,
                required: false,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                currentUser: null,
                inProgress: false,
                reviews: {},
            }
        },

        computed: {
            periodStart: function () {
                if (this.helper.isCyclePlan(this.user.plan)) {
                    return moment(this.currentUser.subscription.current_period_start).format('YYYY年M月D日 HH:mm')
                }
                return moment(this.currentUser.subscription.period_start).format('YYYY年M月D日')
            },

            periodEnd: function () {
                if (this.helper.isCyclePlan(this.user.plan)) {
                    return moment(this.currentUser.subscription.current_period_end).format('YYYY年M月D日 HH:mm')
                }
                return moment(this.currentUser.subscription.period_end).format('YYYY年M月D日')
            },

            cycleWillUpdateAt: function () {
                return moment(this.currentUser.subscription.current_period_end).add(1, 'seconds').format('YYYY年M月D日')
            },

            canceledAt: function () {
                if (!this.currentUser.subscription.canceled_at) return null
                return moment(this.currentUser.subscription.canceled_at).format('YYYY年M月D日 HH:mm')
            },

            pausedAt: function () {
                if (!this.currentUser.subscription.paused_at) return null
                return moment(this.currentUser.subscription.paused_at).format('YYYY年M月D日 HH:mm')
            },

            canCancel: function () {
                // グループに所属している会員はキャンセル不可
                if (this.helper.isGroupUser(this.user)) {
                    return false
                }
                // 買い切りプランの場合はご利用期間の開始前のみキャンセル可能
                if (this.helper.isPurchasePlan(this.user.plan)) {
                    return this.cancelable && this.helper.isStatusNotStarted(this.user.subscription)
                }
                return this.cancelable && this.currentUser.subscription.canceled_at === null
            },

            shouldUpload: function () {
                return this.currentUser.plan.is_upload_document
                    && !this.currentUser.subscription.review.document_url
            },
        },

        created: function () {
            this.currentUser = { ...this.user }
            bus.$on('retry-payment-completed', this.updateSubscription)
            bus.$on('subscription-canceled', this.fetchMe)
            bus.$on('subscription-document-uploaded', this.fetchMe)
        },

        beforeDestroy: function () {
            bus.$off('retry-payment-completed')
            bus.$off('subscription-canceled')
            bus.$off('subscription-document-uploaded')
        },

        methods: {
            /**
             * 支払い再試行完了後のデータ更新
             *
             * @param {object} invoice
             */
            updateSubscription: function (invoice) {
                if (this.currentUser.subscription && this.currentUser.subscription.id === invoice.subscription_id) {
                    const timer = setInterval(() => {
                        axios.get(constants.user.me.endpoint.base)
                            .then(({data}) => {
                                this.currentUser = data.data

                                // 支払い再試行後の更新されたサブスクリプションが取得できたら終了
                                if (this.currentUser.subscription.paused_at === null) {
                                    clearInterval(timer)
                                }
                            })
                    }, 3000)
                }
            },

            /**
             * ログインユーザ取得
             */
            fetchMe: async function () {
                if (this.inProgress) return
                this.inProgress = true

                await axios.get(constants.user.me.endpoint.base)
                    .then(({data}) => {
                        this.currentUser = data.data
                    })

                this.inProgress = false
            },

            /**
             * サービスのキャンセルモーダル表示
             */
            openModalSubscriptionCancel: function () {
                bus.$emit('open-modal-subscription-cancel', this.user, this.user.plan, this.user.subscription)
            },

            /**
             * 書類のアップロードモーダル表示
             */
             openModalSubscriptionFileUpload: function () {
                bus.$emit('open-modal-subscription-file-upload')
            },

        },
    }
</script>

<style scoped lang="scss">
.subscriptionName {
    color: #333;
    font-size: 1.1rem;
    font-weight: bold;
}

.subscriptionPeriod {
    color: #333;
    font-size: 0.85rem;
}
</style>
